import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "profile" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "logo"
}

import { IonButton, IonIcon, IonText, IonHeader, IonToolbar, IonContent, IonImg } from '@ionic/vue';
import { pagesNav } from '@/const/menu';
import ProfileUser from '@/modules/General/components/ProfileUser.vue';
import {useBreakpoint } from '@/hooks/useBreakpoint'
import { appNav } from '@/const/navigation';
import router from "@/router";
import {RouteNamesEnum} from "@/const/routes";
import { ProfileSettingsEnum, RegistrationProgress } from "@/gql/graphql";
import { MenuItem } from '@/interfaces/MenuItem';
import { MenuButton } from '@/interfaces/MenuButton';
import { isAbleToDo } from '@/helpers/isAbleToDo';
import { getReadableRole } from '@/helpers/companyRolesMap'
import { NavigationItem } from '@/interfaces/NavigationItem';
import { computed } from 'vue';
import { useUserStore } from '../store/userStore';
import { hasUnreadEvents } from "@/helpers/setUnreadEvents";
import { hasUnseenMessages } from "@/helpers/setUnseenMessages";
import { EventNamesEnum } from '@/const/events';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationMenu',
  setup(__props, { emit: __emit }) {

const user = computed(() => useUserStore()?.user);
const route = useRoute();

const isActiveSubscriber = computed(() => user.value?.team?.is_active_subscriber || (user.value?.is_impersonated && (user.value?.registration_progress === RegistrationProgress.Completed || user.value?.registration_progress === RegistrationProgress.Admin)));

const { isDesktop } = useBreakpoint();

const openPostJob = () => {
  router.push({
    name: RouteNamesEnum.PostJobChoose
  });
};

const emits = __emit;

const navigate = (item: MenuItem | MenuButton | NavigationItem) => {
  if((isActiveSubscriber.value && user.value?.has_full_access) || item?.isAlwaysVisible || (isActiveSubscriber.value && !user.value?.has_full_access && item?.route !== RouteNamesEnum.Accounting)) {
    emits(EventNamesEnum.OnNavigate, item);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), { class: "header" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), {
          class: _normalizeClass({'transparent': _unref(isDesktop)})
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(IonText), { class: "profile__title" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getReadableRole)(user.value?.team?.types?.[0]?.name)), 1)
                ]),
                _: 1
              }),
              _createVNode(ProfileUser, {
                "avatar-src": user.value?.avatar_url,
                "team-name": user.value?.team?.company_name,
                "user-name": user.value?.name_first + ' ' + user.value?.name_last,
                "title-id": "User ID",
                "member-id": user.value?.team?.id,
                "user-id": user.value?.id,
                "user-rating": +user.value?.team?.score,
                "is-tracking": _unref(isAbleToDo)(user.value, _unref(ProfileSettingsEnum).Tracking),
                "has-unread-events": _unref(hasUnreadEvents),
                onOnNavigate: _cache[0] || (_cache[0] = ($event: any) => (navigate($event))),
                "hide-notice-button": !isActiveSubscriber.value
              }, null, 8, ["avatar-src", "team-name", "user-name", "member-id", "user-id", "user-rating", "is-tracking", "has-unread-events", "hide-notice-button"])
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({'aside-menu': _unref(isDesktop)})
        }, [
          _createVNode(_unref(IonButton), {
            class: "aside-menu__post-job",
            onClick: openPostJob,
            disabled: !_unref(isAbleToDo)(user.value, _unref(ProfileSettingsEnum).PostWork) || !isActiveSubscriber.value
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createTextVNode(" Post a job ")),
              _createVNode(_unref(IonIcon), {
                slot: "end",
                src: "assets/icon/plus.svg"
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appNav).filter(i => !i.isMainButton), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "side-menu-link",
              key: item.name,
              onClick: ($event: any) => (isActiveSubscriber.value ? navigate(item) : null)
            }, [
              _createVNode(_unref(IonButton), {
                fill: "clear",
                class: "side-menu-button",
                disabled: !isActiveSubscriber.value
              }, {
                default: _withCtx(() => [
                  (_unref(route)?.path?.includes(item?.url))
                    ? (_openBlock(), _createBlock(_unref(IonIcon), {
                        key: 0,
                        class: "side-menu-button__dot",
                        src: "assets/icon/dot.svg"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonIcon), {
                    class: "side-menu-button__icon",
                    src: item.icon
                  }, null, 8, ["src"]),
                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["disabled"])
            ], 8, _hoisted_2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonContent), {
      class: _normalizeClass(["ion-padding", {'transparent': _unref(isDesktop)}])
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagesNav), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["side-menu-link", {'side-menu-link--disabled': user.value?.has_full_access ? false : item.route === _unref(RouteNamesEnum).Accounting}]),
            key: item.name,
            onClick: ($event: any) => (navigate(item))
          }, [
            (item.route)
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 0,
                  fill: "clear",
                  class: "side-menu-button",
                  disabled: !isActiveSubscriber.value && !item?.isAlwaysVisible
                }, {
                  default: _withCtx(() => [
                    (item?.urls?.some(item => _unref(route)?.path.includes(item)))
                      ? (_openBlock(), _createBlock(_unref(IonIcon), {
                          key: 0,
                          class: "side-menu-button__dot",
                          src: "assets/icon/dot.svg"
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IonIcon), {
                      class: "side-menu-button__icon",
                      src: item.icon
                    }, null, 8, ["src"]),
                    _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                    (item.name === 'Messages' && _unref(hasUnseenMessages))
                      ? (_openBlock(), _createBlock(_unref(IonImg), {
                          key: 1,
                          src: "assets/icon/red-dot.svg",
                          class: "red-dot"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["disabled"]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 128))
      ]),
      _: 1
    }, 8, ["class"]),
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(IonImg), { src: "assets/icon/logo.svg" })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})